export default __webpack_public_path__ + "static/media/withoutNotification.ccefe3e5.svg";